// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 3 ? "build-glob" : chunkId) + "-legacy." + {"3":"3e276884","121":"0c0af326","263":"00cc52e3","351":"dbeae1a9","719":"e8e32dae","876":"2f8bb98c"}[chunkId] + ".js";
};